module.exports = __webpack_public_path__ + "static/media/delete.fe9b66c3.svg";